<template>
  <div class="contract-searcher__wrapper md-layout md-layout-item md-alignment-center-center">
    <div class="contract-searcher__inner md-layout md-gutter md-layout-item md-size-95">
      <div class="contract-searcher__filters-wrapper">
        <div class="contract-searcher__filter">
          <input-field
            v-model="form.counterparty"
            name="counterparty"
            title="Counterparty"
            :placeholder="i18n.cont_counterparty()"
            :label="i18n.cont_counterparty_name()"
          />
        </div>
        <div class="contract-searcher__filter">
          <input-field
            v-model="form.contractNumber"
            name="contract-number"
            title="Contract number"
            :label="i18n.cont_contract_number()"
          />
        </div>
        <div class="contract-searcher__filter">
          <date-field-flatpickr
            v-model="form.startDate"
            name="contract-start-date"
            title="Contract start date"
            :disableAfter="form.endDate"
            :label="i18n.lbl_start_date()"
          />
       </div>
        <div class="contract-searcher__filter">
          <date-field-flatpickr
            v-model="form.endDate"
            name="contract-end-date"
            title="Contract end date"
            :disableBefore="form.startDate"
            :label="i18n.lbl_end_date()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import FormMixin from '@com/mixins/form.mixin'
  import { i18n } from '@js/i18n'
  import { validateAccountId, validateEmail } from '@validator/validator'
  import { accountsService } from '@api/accounts.service'
  import { usersService } from '@api/users.service'
  import { DateHelper } from '@js/helpers/date.helper'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import debounce from 'lodash/debounce'

  export default {
    name: 'signed-contracts-searcher',
    mixins: [FormMixin],

    components: {
    },

    props: [],

    data () {
      return {
        form: {
          counterparty: '',
          contractNumber: '',
          startDate: null,
          endDate: null
        },
        eventEmitter: null,
        i18n
      }
    },

    methods: {
      async loadCounterparty () {
        const providedCounterparty = this.form.counterparty
        if (!providedCounterparty) return ''
        if (validateAccountId(providedCounterparty)) {
          return providedCounterparty
        } else if (validateEmail(providedCounterparty)) {
          const counterpartyId = await accountsService.loadAccountIdByEmail(providedCounterparty)
          if (!counterpartyId) {
            EventDispatcher.dispatchShowErrorEvent(i18n.cont_email_invalid())
            return
          }
          return counterpartyId
        } else {
          const counterpartyList = (await usersService.loadСorporateUsers({companyName: providedCounterparty})).data()
          if (!Array.isArray(counterpartyList) || counterpartyList.length !== 1) {
            EventDispatcher.dispatchShowErrorEvent(i18n.cont_counterparty_invalid())
            return
          }
          return counterpartyList[0].id
        }
      },
      async composeFilters () {
        const counterparty = await this.loadCounterparty()
        if (typeof counterparty === 'undefined') return
        const filters = {
          counterparty: counterparty,
          contractNumber: this.form.contractNumber,
          startDate: this.form.startDate ? DateHelper.toTimestamp(this.form.startDate) : '',
          endDate: this.form.endDate ? DateHelper.toTimestamp(this.form.endDate) : ''
        }
        this.$emit('compose-filters', filters)
      }
    },

    watch: {
      'form.counterparty': debounce(function () { this.composeFilters() }, 1000),
      'form.contractNumber': debounce(function () { this.composeFilters() }, 1000),
      'form.startDate': debounce(function () { this.composeFilters() }, 1000),
      'form.endDate': debounce(function () { this.composeFilters() }, 1000)
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .contract-searcher__inner {
    flex-direction: column;
    margin-top: 1rem;
  }

  .contract-searcher__filters-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    & .contract-searcher__filter {
      width: 24%;
      display: inherit;
      justify-content: inherit;
    }
  }

  .contract-searcher__wrapper {
    background: $default-white;
    // box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.08);
    border-radius: 2px;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/contracts/index/Contracts.Searcher.vue